{
  "states": {
    "loading": "Inapakia...",
    "unavailable": "--"
  },
  "button": {
    "defaultCity": "San Francisco"
  },
  "conditions": {
    "Clear": "Wazi",
    "Clouds": "Mawingu",
    "Rain": "Mvua",
    "Drizzle": "Manyunyu",
    "Thunderstorm": "Dhoruba ya radi",
    "Snow": "Theluji",
    "Mist": "Ukungu mwepesi",
    "Smoke": "Moshi",
    "Haze": "Ukungu",
    "Dust": "Vumbi",
    "Fog": "Ukungu mzito",
    "Sand": "Mchanga",
    "Ash": "Majivu",
    "Squall": "Upepo mkali",
    "Tornado": "Kimbunga"
  },
  "modal": {
    "defaultTitle": "Hali ya Hewa",
    "subtitle": "Hali ya sasa",
    "showFahrenheit_aria": "Onyesha Fahrenheit",
    "showCelsius_aria": "Onyesha Selsiasi",
    "switchToCelsius_title": "Badilisha hadi °C",
    "switchToFahrenheit_title": "Badilisha hadi °F",
    "feelsLike": "Inahisi kama {{temp}}°{{unit}}",
    "humidityWind": "Unyevu {{humidity}}% · Upepo {{wind}}",
    "windSpeed": "{{speed}} mph",
    "hourlyNow": "Sasa",
    "hourlyOffset": "{{hours}}sa",
    "hourlyStrip_aria": "Halijoto ya kila saa",
    "hourlyLocked": "Utabiri wa kila saa ni kipengele cha Pro.",
    "statsLocked": "Maelezo ya hali ya hewa ni kipengele cha Pro.",
    "stats": {
      "sunrise": "Macheo",
      "sunset": "Machweo",
      "feels": "Inahisi",
      "humidity": "Unyevu",
      "wind": "Upepo",
      "rain": "Mvua"
    },
    "rainInches": "{{value}} inchi",
    "forecastTitle": "Utabiri wa Siku 5",
    "forecastLoading": "Inapakia utabiri…",
    "forecastUnavailable": "Utabiri haupatikani",
    "forecastLocked": "Utabiri wa siku 5 ni kipengele cha Pro.",
    "forecastRow_aria": "Utabiri wa siku tano",
    "proHeadline": "Utabiri kamili ni sehemu ya Pro.",
    "proFeatures": "Kila saa · Hali za kina · Mtazamo wa siku 5."
  }
}
